import * as SurveyAPI from '../services/SurveyAPI';
import { ActionTypes } from './ActionTypes';

export const SurveyBenchmarkActionCreators = {
	GetSurveyBenchmarks: (surveyId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_BENCHMARKS_GET_REQUESTED });

		return SurveyAPI.getSurveyBenchmarks(surveyId).then((benchmarkIds: number[]) =>
			dispatch({ type: ActionTypes.SURVEY_BENCHMARKS_GET_SUCCEEDED, payload: benchmarkIds }),
		);
	},
	SaveSurveyBenchmarks: (surveyId: number, benchmarkIds: number[]) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_BENCHMARKS_SAVE_REQUESTED });

		return SurveyAPI.saveSurveyBenchmarks(surveyId, benchmarkIds).then((responseBenchmarkIds: number[]) => {
			dispatch({
				type: ActionTypes.SURVEY_BENCHMARKS_SAVE_SUCCEEDED,
				payload: responseBenchmarkIds,
			});
			dispatch({ type: ActionTypes.TOAST_SUCCESS_GENERIC_NOTIFICATION });
		});
	},
};
